import Pristine from 'pristinejs';
import scrollTo from '../common/scrollTo';

const $form = document.querySelector('form.scholarship-form__form');

const SELECTORS = Selectors({
    formAnchor: '[data-form-anchor]',
    loading: 'is-loading',
    formErrorMessage: 'form-error-message'
});

export const pristineConfig = {
    classTo: 'field',
    errorClass: 'has-error',
    successClass: 'has-success',
    errorTextParent: 'field',
    errorTextTag: 'div',
    errorTextClass: 'text-help',
};

const fn = {
    init: () => {

        $form.addEventListener('submit', e => {

            const pristine = new Pristine($form, pristineConfig)
            const valid = pristine.validate()

            if (!valid) {
                e.preventDefault();
                const $firstError = $form.querySelector('.field.has-error');

                if ($firstError) {
                    if ($firstError.classList.contains('textarea')) {
                        scrollTo($firstError, 150, () => $firstError.querySelector('textarea').focus());
                    }
                    else if ($firstError.classList.contains('dropdown')) {
                        scrollTo($firstError, 150, () => $firstError.querySelector('dropdown'));
                    }
                    else {
                        scrollTo($firstError, 150, () => $firstError.querySelector('input').focus());
                    }
                }

                return false;
            }
            else {

                const $submitButton = $form.querySelector('[type=submit]');
                $submitButton.disabled = true;
                $submitButton.classList.add(SELECTORS.loading);

            }
        });

    },

};

export default {
    can: () => $form,
    run: fn.init,
};
